<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-HunNingTu`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.02261 3.20283C8.73946 2.85788 9.58614 2.92314 10.2417 3.37387L14.2276 6.11457C14.3321 6.1864 14.4599 6.21593 14.5853 6.19721L15.56 6.05169C16.492 5.91255 17.4102 6.37729 17.8499 7.2107L21.1 13.3708C21.3633 13.87 21.4266 14.4507 21.2768 14.9948L20.3163 18.4848C20.0513 19.4476 19.1758 20.1147 18.1772 20.1147H6.16276C5.24005 20.1147 4.41366 19.5436 4.08743 18.6805L2.73284 15.0967C2.59607 14.7348 2.55628 14.3435 2.61744 13.9615L3.84906 6.26837C3.96394 5.55081 4.42295 4.93499 5.07778 4.61988L8.02261 3.20283ZM9.26834 4.78943C9.12039 4.6877 8.9293 4.67297 8.76751 4.75082L5.82267 6.16788C5.67488 6.239 5.57128 6.37798 5.54536 6.53994L4.31373 14.2331C4.29993 14.3193 4.30891 14.4076 4.33978 14.4893L5.69437 18.0731C5.768 18.2679 5.95451 18.3968 6.16276 18.3968H18.1772C18.4026 18.3968 18.6002 18.2462 18.66 18.0289L19.6205 14.539C19.6543 14.4162 19.64 14.2851 19.5806 14.1724L16.3305 8.01234C16.2312 7.82424 16.024 7.71935 15.8137 7.75075L14.8389 7.89628C14.2834 7.97921 13.7171 7.84836 13.2543 7.53013L9.26834 4.78943Z"/></svg>
</template>
<script>

export default {
  name: 'IconHunNingTu',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
